import { FC } from "react";
import { LogProvider } from "../components/LogProvider/LogProvider";
import { MediaPlayerContainer } from "../components/MediaPlayerContainer/MediaPlayerContainer";
export const Router: FC = () => {
	return (
		<LogProvider>
			<MediaPlayerContainer />
		</LogProvider>
	)
};